import './input-dropdown.scss'
import { useState } from 'react'
import Button from '../../button/button';
import IconHeader from '../../icon-header/icon-header';
import CheckboxGroup from '../checkbox-group/checkbox-group';

const InputDropdown = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    
    const Modal = () =>
        <div className='dropdown-modal'>
            <div className='dropdown-modal--backdrop' hidden={!isOpen} onClick={() => setIsOpen(false)}/>
            <div style={{ paddingLeft: "calc(50% - 0.75rem)"}} hidden={!isOpen}>
                <div className='dropdown-modal--arrow' />
            </div>
            <div  style={{position:"absolute", marginTop:"11px", minWidth:"200px"}}>
            <dialog className="dropdown-modal--dialog base " aria-modal="true" id={`dialog-${props.name}`} open={isOpen}>
                    <form method="dialog" className='dropdown-modal--content'>
                        <header className='content-header'>
                            <span className='title'>
                                <p className="text lead medium semibold nospace ">
                                    {props.modalLabel || props.label}
                                </p>
                            </span>
                            <span className="control">
                                <button className="icon-button primary medium" type="button" onClick={() => setIsOpen(false)} title="Icon Button">
                                    <span className="icon " style={{ WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", color: "currentColor" }}></span>
                                </button>
                            </span>
                        </header>
                        <section className='main'>
                         {props.children}
                            
                        </section>
                        <menu className='footer' style={{ display: "flex", gap: "var(--space-4)", justifyContent: "flex-end" }}>
                            
                        </menu>
                    </form>

                </dialog>
            </div>
        </div>

    return (
        <div className='input-dropdown'>
        <label htmlFor="input_text_0c347d94f6e_1" className="dropdown-btn">
            <span className={`group ${props.selected > 0 ? 'selected': ''} ${isOpen ? 'active' : ''} `} data-label="" onClick={() => setIsOpen(!isOpen)}>
                <span className='label '>
                    {props.icon &&
                        <span className="icon-leading ">
                            <span className="icon medium" style={{
                                WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`, // Rotate and animate chevron on open
                                maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`,
                                color: "currentColor"
                            }}>
                            </span>
                        </span>


                    }
                    {props.label}</span>
                    <span className="notifications">+{props.selected}</span>
                    <span aria-label="Control" className="icon-control">
                    <span className="icon "
                        style={{ WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", color: "currentColor" }}>
                    </span>
                </span>
           
            </span>
         
        </label>
        <Modal />

        </div>
    )

}

export default InputDropdown;